import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { AlertController, LoadingController, ModalController, IonSearchbar } from '@ionic/angular';


import { Sale } from '../../../models/sale/sale.model';
import { SaleService } from '../../../services/sale.service';

import { Router } from '@angular/router';
import { NavigationStateService } from '../../../services/navigation-state.service';
declare var posthog: any;
@Component({
  selector: 'app-sale-lookup',
  templateUrl: './sale-lookup.page.html',
  styleUrls: ['./sale-lookup.page.scss'],
})
export class SaleLookupPage implements OnInit {

  //@ViewChild('searchBar') searchBar: Searchbar;
  @ViewChild(IonSearchbar) clientSearchBar: IonSearchbar;
  public searchTerm: string;

  public searchField: UntypedFormControl;

  public searchForm: UntypedFormGroup;

  constructor (private alertCtrl: AlertController,
              private saleService: SaleService,
              //private viewCtrl: ViewController,
              //private navController: NavController,
              private loadingCtrl: LoadingController,
              private formBuilder: UntypedFormBuilder,
              private changeDetectorRef: ChangeDetectorRef,
              //private searchBar:Searchbar,
              private modalCtrl: ModalController,
              private router:Router,
              private navigationStateService: NavigationStateService) {
    this.searchTerm = '';
    this.searchField = new UntypedFormControl();
    this.searchForm = this.formBuilder.group({
      searchField: this.searchField
    });
  }

  public ngOnInit () {
    setTimeout(() => {
      this.clientSearchBar.setFocus();
    },150);
  }

  public dismiss () {
    //this.viewCtrl.dismiss();  
    this.modalCtrl.dismiss();  
    
  }

  public async searchSale () {

    if (!this.searchTerm || this.searchTerm === '') {
      return;
    }

    const loader = await this.loadingCtrl.create({ spinner: 'crescent' });
    loader.present();
    this.saleService.searchSaleByUUID(this.searchTerm.trim())
      .subscribe({
        next:(sale: Sale) => {
          loader.dismiss().then(() => {

            if (sale) {
              new Promise((resolve, reject) => {
                posthog.capture('$pageview');

              this.navigationStateService.setState({
                saleID: sale.id, 
              });

                this.router.navigate(
                  ['/sales/sale-receipt']
                );
              })
              .then((callBackData) => {

              });
            }
          
          });
        },
        error: async(error) => {
          loader.dismiss().then(async() => {
            const alert = await this.alertCtrl.create({
              message: `Oops! No sale found. Please try again!`,
              buttons: ['OK']
            });
            alert.present();
            
          });
        }
  });
  }

}
